import '~/js/modules/countdown';
import '~/js/modules/subscribe-form';

/* eslint-disable */

import QualifyingRoomsSuites from '~/js/components/specials/qualifying-rooms-suites/QualifyingRoomsSuites';

// Variable Declaration
const roomsAndSuites = document.querySelector('#qualifying-rooms-suites');

// Render react component
ReactDOM.render(<QualifyingRoomsSuites />, roomsAndSuites);
